// extracted by mini-css-extract-plugin
export default {"entity":"Entity_entity__eJ8wN","gridContainer":"Entity_gridContainer__ANqLm","icon":"Entity_icon__s1wQr","content":"Entity_content__aT-b-","value":"Entity_value__eQdIE"};